"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXs, ColorWhite, FontLineHeightMd, FontWeightBold, FontLineHeightSm, FontWeightDefault, FontSize400, FontSize3, ColorTextDefault, FontSize100, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const StyledTieredCardLeftTile = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "background" && prop !== "alignment" && prop !== "collapseOnTablet"
})(({
  background,
  alignment,
  collapseOnTablet
}) => {
  return {
    ["@media (min-width: 768px) and (max-width:1023px)"]: {
      width: collapseOnTablet ? "100%" : "50%",
      flexDirection: collapseOnTablet ? "column" : "row"
    },
    ["@media (max-width: 767px) "]: {
      width: "100%",
      flexDirection: "column"
    },
    background,
    display: "flex",
    justifyContent: alignment === "top" ? "flex-start" : alignment === "middle" ? "center" : "flex-end",
    width: "50%",
    flexDirection: "row"
  };
});
const StyledTieredCardRightTile = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "background" && prop !== "collapseOnTablet"
})(({
  background,
  collapseOnTablet
}) => {
  return {
    ["@media (min-width: 768px) and (max-width:1023px)"]: {
      width: collapseOnTablet ? "100%" : "50%"
    },
    ["@media (max-width: 767px) "]: {
      width: "100%",
      flexDirection: "column"
    },
    background,
    display: "flex",
    width: "50%"
  };
});
const RightTileContent = styled(CostcoBox)({
  display: "flex",
  alignContent: "flex-start"
});
const StyledTileBlock = styled(CostcoBox)({
  border: `3px solid ${ColorWhite}`,
  borderRadius: "4px",
  display: "inline-block",
  margin: "5px",
  maxWidth: "100%",
  padding: SpaceXs
});
const StyledBoldText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "textColor"
})(({ textColor }) => {
  return {
    ["@media (max-width: 768px)"]: {
      fontSize: "20px",
      lineHeight: FontLineHeightSm
    },
    color: textColor,
    fontSize: "30px",
    fontWeight: FontWeightBold,
    lineHeight: FontLineHeightMd
  };
});
const StyledNormalText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "textColor"
})(({ textColor }) => {
  return {
    ["@media (max-width: 768px)"]: {
      fontSize: FontSize3
    },
    color: textColor,
    fontSize: FontSize400,
    fontWeight: FontWeightDefault,
    lineHeight: 1.3
  };
});
const StyledPillContainer = styled(CostcoBox)`
    display: inline-flex;
    padding: 0px 10px;
    position: relative;
    width: auto;
    z-index: 1;
    margin-bottom: -5px;
    top: 10px;
    justify-content: center;
`;
const StyledOverlay = styled(Box)`
    border-radius: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    padding: 2px 8px;
    gap: 10px;
    max-width: 250px;
    max-height: 22px;
`;
const StyledOverlayTextContainer = styled(Box)`
   border-radius: 4px;
   position: relative; 
   top:50px  
   left: 0;
   width: 100%; 
   background-color: ${ColorTextDefault}; 
   z-index:0;
   padding: 16px 8px 8px;
   align-items: center;
   justify-content:center;
   gap:30px;
`;
const StyledOverlayText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "textColor"
})(({ textColor }) => {
  return {
    color: textColor,
    fontSize: FontSize100,
    fontWeight: FontWeightDefault,
    lineHeight: FontLineHeightMd
  };
});
const StyledOverlayMarkdown = styled(Text, {
  shouldForwardProp: (prop) => prop !== "textColor"
})(({ textColor }) => {
  return {
    color: textColor,
    fontSize: FontSize300,
    fontWeight: FontWeightDefault,
    lineHeight: FontLineHeightMd
  };
});
const StyledOverlayTileBox = styled(CostcoBox)({
  borderRadius: "6px",
  display: "inline-block",
  margin: "5px",
  maxWidth: "100%",
  position: "relative"
});
const TieredCardContainerSx = {
  borderRadius: "10px",
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  flexWrap: "wrap",
  overflow: "hidden",
  textDecoration: "none",
  width: "100%"
};
export {
  RightTileContent,
  StyledBoldText,
  StyledNormalText,
  StyledOverlay,
  StyledOverlayMarkdown,
  StyledOverlayText,
  StyledOverlayTextContainer,
  StyledOverlayTileBox,
  StyledPillContainer,
  StyledTieredCardLeftTile,
  StyledTieredCardRightTile,
  StyledTileBlock,
  TieredCardContainerSx
};
